import React from "react";
import QueryForm from "./QueryForm";
const SupportPanel = () => {
  return (
    <div className="supportPanel">
      {/* <div className="header flex flex-col items-center bg-[#fbd10b] p-24">
        <div className="topText text-sm font-bold">FAQs</div>
        <div className="MainText text-[#387171] text-4xl font-bold">
          Ask us anything
        </div>
        <div className="descriptiveText text-sm font-light my-2">
          Have any questions? We're here to assist you.
        </div>
        <div className="relative">
        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
          <FiSearch  />
        </span>
        <input type="text" name="q" className="w-[15rem] py-2 text-sm text-black bg-white rounded-md pl-10 focus:outline-none focus:bg-white" placeholder="Search..." autocomplete="off" />

        </div>
      </div> */}
      {/* <div className="flex flex-wrap justify-between items-center px-20 ">
        {cardsData.map((item, index) => (
          <QueryCard
            icon={item.icon}
            question={item.question}
            answer={item.answer}
          />
        ))}
      </div> */}
      {/* Query Form */}
      <QueryForm />
    </div>
  );
};

export default SupportPanel;
